// Bulk Upload v2 client (build doc 06 §2.4, §4.1; 90 #1, #37, #48). Only the
// two bulk-specific routes live here; every other ingestion call (typed,
// files/register, start, commands, undo, commit, reopen, page-urls, roster)
// reuses service/exams.api.js, the same client Exams uses. Both helpers throw
// ExamsApiError {status, code, message, details}; neither resolves null.
import { examsRequest, queryString } from './exams.api';

/**
 * GET /bulk-upload/pipeline?assignmentId=&client=web|mobile →
 * {pipeline: 'v1'|'v2', pinned, reason, ingestionJobId, autoSort}.
 * No assignmentId: the teacher's default (nothing can be pinned yet).
 */
export const getBulkUploadPipeline = (
  { assignmentId = null, client = 'web' } = {},
  { signal } = {}
) =>
  examsRequest(
    `/bulk-upload/pipeline${queryString({ assignmentId, client })}`,
    {
      signal,
    }
  );

/**
 * POST /ingestion {ownerKind: BULK_UPLOAD, ownerId, mode} → 201 IngestionView,
 * or 200 with the assignment's open job. 409 BULK_UPLOAD_PIPELINE_PINNED
 * (the draft is on v1), 403 PLAN_REQUIRED, 404 ASSIGNMENT_NOT_FOUND.
 */
export const createBulkIngestion = ({ assignmentId, mode = 'AUTO' }) =>
  examsRequest('/ingestion', {
    method: 'POST',
    body: { ownerKind: 'BULK_UPLOAD', ownerId: assignmentId, mode },
  });
